import React from 'react';
import { useTheme } from '@mui/material';
import { BounceLoader } from 'react-spinners';

const Loader = () => {
  const theme = useTheme();
  return (
    <BounceLoader color={theme.palette.primary.main} cssOverride={{ marginBottom: theme.spacing(4) }} />
  );
};

export default Loader;
